// Tiny coordination flag between the assistant's action executor and the global
// ScrollToTop component. When the assistant navigates in order to highlight a
// section, it asks ScrollToTop to skip its one-time scroll-to-top reset so the
// two don't fight over the scroll position.

let skipOnce = false

export function requestSkipAutoScroll(): void {
  skipOnce = true
}

/** Returns true once (and resets) if an auto-scroll reset should be skipped. */
export function consumeSkipAutoScroll(): boolean {
  if (skipOnce) {
    skipOnce = false
    return true
  }
  return false
}
